<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <el-table
          :key="renderKey"
          :data="reconciliationStatuses.reconciliationStatusList"
        >
          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :formatter="column.formatter"
            :prop="column.prop"
            :label="column.label"
          >
          </el-table-column>
          <el-table-column
            min-width="150"
            sortable
            prop="reconciliationAmount"
            label="Reconciliation Amount"
          >
            <editable-cell
              :disabled="isReadOnly || isPartnerAccount"
              :show-input="editMode"
              :min=0
              slot-scope="{ row }"
              editable-component="el-input-number"
              close-event="change"
              v-model="row.reconciliationAmount"
            >
              <span slot="content">
                {{ row.reconciliationAmountInMoneyFormat }}
              </span>
            </editable-cell>
          </el-table-column>
          <el-table-column
            min-width="150"
            prop="reconciliationDate"
            sortable
            label="Reconciliation Date"
          >
            <editable-cell
              :disabled="isReadOnly || isPartnerAccount"
              :show-input="editMode"
              slot-scope="{ row }"
              editable-component="el-date-picker"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              close-event="change"
              v-model="row.reconciliationDate"
            >
              <span slot="content">
                {{ GetDate(row.reconciliationDate) }}
              </span>
            </editable-cell>
          </el-table-column>

          <el-table-column
            min-width="150"
            sortable
            prop="outstandingBalanceInMoneyFormat"
            label="Outstanding Balance"
          >
            <template slot-scope="props">
              {{ props.row.outstandingBalanceInMoneyFormat }}
            </template>
          </el-table-column>
        </el-table>

        <div class="row">
          <div class="col-sm-6">
            <label>Outstanding Balance Date</label>
            <el-date-picker
              v-model="reconciliationStatuses.outstandingBalanceDate"
              :disabled="isReadOnly || !editMode || !isPartnerAccount"
              type="date"
              format="dd-MMMM-yyyy"
              placeholder="Outstanding Balance Date"
            >
            </el-date-picker>
          </div>
        </div>

        <div
          style="margin-top: 20px; float: right"
          v-if="(!isReadOnly || hasData) && !isPartnerAccount"
        >
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            v-show="editMode"
            type="danger"
            class="alert_footer_button mr-4 btn_extra_small btn_info"
            @click.native="cancelEditMode"
          >
            Cancel
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="handleEdit()"
          >
            {{ editMode ? "Save" : "Edit" }}
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, Modal } from "@/components";
import FinanceSystemModal from "@/components/App/order/invoice/fundcitation/FinanceSystemModal.vue";
import EditableCell from "@/components/App/order/completion/FundCitiationEditable.vue";
import swal from "sweetalert2";
import Util from "@/util/util";

export default {
  name: "reconciliation-status",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    FinanceSystemModal,
    EditableCell,
  },

  data() {
    return {
      editMode: false,
      editing: null,
      renderKey: 0,
      tableColumns: [
        {
          prop: "fundCitationName",
          label: "Fund Citation",
          minWidth: 100,
        },
        {
          prop: "fundCitationAbbreviation",
          label: "Abbreviation",
          minWidth: 100,
        },
        {
          prop: "fundCitationTotalCostInMoneyFormat",
          label: "Total Cost Per Fund Citation",
          minWidth: 180,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      reconciliationStatuses: "reconciliationStatus/reconciliationStatuses",
      reconciliationErrors: "reconciliationStatus/reconciliationErrors",
      preOrder: "preOrderDetail/preOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
    isNotApplicableEntryAdded() {
      let existingNotApplicableEntry = this.reconciliationStatuses.find(
        (fundCitation) => fundCitation.abbreviation === "NA"
      );

      return !!existingNotApplicableEntry;
    },
    hasData() {
      return this.reconciliationStatuses.length > 0;
    },
  },
  methods: {
    ...mapActions({
      getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
      getReconciliationData: "reconciliationStatus/getReconciliationData",
      getReconciliationStatusInformation:
        "reconciliationStatus/getReconciliationStatusInformation",
      saveReconciliationStatus: "reconciliationStatus/saveReconciliationStatus",
    }),
    deleteErrorOccurred(error) {
      new swal({
        title: "Cannot Delete Fund Citation",
        text: `Fund Citation is active in line item.`,
        icon: "error",
        confirmButtonColor: "#10b45a",
        confirmButtonText: `Ok`,
      });
    },
    loaded() {
      this.getReconciliationData(this.$route.params.id);
      this.getReconciliationStatusInformation(this.$route.params.id);
    },
    GetDate(date) {
      return Util.convertToDateOnly(date);
    },
  
    async handleEdit() {
      if (this.editMode) {
        var apiInfo = {
          ReconciliationStatusList:
            this.reconciliationStatuses.reconciliationStatusList,
          OutstandingBalanceDate:
            this.reconciliationStatuses.outstandingBalanceDate,
        };
        await this.saveReconciliationStatus(apiInfo);
        await this.getReconciliationStatus(this.$route.params.id);
        this.getReconciliationData(this.$route.params.id);
        this.getReconciliationStatusInformation(this.$route.params.id).then(() => {
        });
        await this.renderKey++;
        this.editMode = false;
      } else {
        this.editMode = true;
      }
    },
    cancelEditMode() {
      this.editMode = false;
    },
    addNotApplicableEntry() {
      this.fundCitation.name = "Not Applicable";
      this.fundCitation.abbreviation = "NA";

      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx
            .saveReconciliationStatus(ctx.$route.params.id)
            .then((response) => {
              ctx.getReconciliationStatus(ctx.$route.params.id);
              ctx.getReconciliationStatusInformation(ctx.$route.params.id);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.not_applicable {
  background-color: #f0ad4e !important;
  border: #f0ad4e !important;
  background-image: none !important;
}
</style>
